import React from "react";
import { useNavigate } from "react-router-dom";
import AppHeader from "../components/AppHeader";
import SiteFooter from "../components/SiteFooter";
import { useAuth } from "../AuthContext";

export default function Landing() {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="page" data-testid="landing-page">
      <div className="grain-bg" />
      <div className="container-narrow">
        <AppHeader />

        <div className="fade-in" style={{ paddingTop: "8vh" }}>
          <div className="eyebrow" style={{ marginBottom: 20 }}>The Daily Reframe</div>

          <h1 className="hero-title" data-testid="landing-headline">
            What's looping<br />in your head today?
          </h1>

          <p
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontStyle: "italic",
              fontWeight: 600,
              fontSize: 21,
              lineHeight: 1.6,
              color: "#1a1008",
              maxWidth: 520,
              margin: "0 0 48px",
            }}
          >
            A quiet companion for the thoughts you can't put down.
            Drop one in. Get a calm reframe. Then carry an anchor for the day.
          </p>

          <div style={{ display: "flex", gap: 28, alignItems: "center", flexWrap: "wrap", marginBottom: 72 }}>
            <button
              className="btn-primary"
              onClick={() => navigate(user ? "/app" : "/register")}
              data-testid="landing-cta-begin"
            >
              {user ? "Open the app" : "Begin — it's free"}
            </button>
          </div>

          <div className="divider" />

          <div style={{ marginTop: 48 }}>
            <div className="eyebrow" style={{ marginBottom: 24 }}>What you get</div>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {[
                "One free reframe every day — no card required",
                "A private journal of every reframe, saved across devices",
                "Unlimited reframes on the membership ($9/mo or $79/yr)",
                "No clinical talk. No diagnoses. Plain spoken. Direct."
              ].map((t, i) => (
                <li
                  key={i}
                  style={{
                    fontFamily: "'Cormorant Garamond', serif",
                    fontStyle: "italic",
                    fontWeight: 600,
                    fontSize: 22,
                    color: "#1a1008",
                    lineHeight: 1.6,
                    padding: "14px 0",
                    borderBottom: i < 3 ? "1px solid var(--hairline)" : "none",
                  }}
                >
                  {t}
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-tag" data-testid="landing-tagline">Let Go. Live Free. Love Fully.</div>
        </div>
        <SiteFooter showTagline={false} />
      </div>
    </div>
  );
}
